import React from 'react';

import { TooltipProps } from './types';
import { Component, Text } from './styles';

export const Tooltip = React.memo<TooltipProps>(({ info }) => {
  return (
    <Component>
      <Text>{info}</Text>
    </Component>
  );
});
